import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGetSection() {
  const items = ['El Manual "Rutinas de Conexión Express" en formato PDF listo para leer en el móvil.', 'El Protocolo "Aterrizaje Suave" paso a paso para el trayecto en coche y la entrada en casa.', 'Guía de Micro-Momentos adaptada por edades (de 6 a 18 años).', 'Plantilla de "Blindaje ante el Conflicto" para que la tensión con tu ex no arruine el reencuentro.', 'Checklist de preparación del hogar para crear un entorno de pertenencia inmediato.'];
  return <section className="py-16 md:py-24 px-4 bg-brand-cream" data-id="element-147">
      <div className="max-w-2xl mx-auto" data-id="element-148">
        <FadeIn data-id="element-149">
          <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center" data-id="element-150">
            Lo que te llevas hoy
          </h2>
          <div className="bg-white p-8 rounded-xl shadow-sm border border-brand-amber/20" data-id="element-151">
            <ul className="space-y-6" data-id="element-152">
              {items.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-153">
                  <CheckCircle2 className="w-6 h-6 text-brand-amber flex-shrink-0 mt-1" data-id="element-154" />
                  <span className="text-lg leading-relaxed" data-id="element-155">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}